import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { CCol, CRow, CButton, CAlert, CSpinner, CCard, CCardBody } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilArrowLeft } from '@coreui/icons'
import { api, currentUser } from '../api/client'

// Vista de la Categoria [RGM] 2026-10-05 (pedido Rafael: "a las filas producto,
// categoria y subcategoria etc debe llevar al view"): mismo formato de la
// factura — azul institucional #078bcd + tarjetas .factura-panel — con la
// lista del endpoint y la fila localizada por código (patrón CobradorViewPage).
const PRIMARY_BLUE = '#078bcd'

const CategoriaViewPage: React.FC = () => {
  const { codigo } = useParams<{ codigo: string }>()
  const navigate = useNavigate()
  const user = currentUser()
  const empresa = user?.companyId ?? '01'
  const [categoria, setCategoria] = useState<any>(null)
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    setCargando(true)
    // El listado ya trae todos los campos (CatalogosController GET — sin
    // GET /catalogos/categorias/{nro}); se localiza la fila por código.
    api.get<any[]>(`/catalogos/categorias?empresa=${empresa}`)
      .then((rows) => setCategoria(
        (rows ?? []).find((r) => String(r.categoriaNro) === String(codigo)) ?? null))
      .catch(() => setCategoria(null))
      .finally(() => setCargando(false))
  }, [codigo, empresa])

  if (cargando) {
    return (
      <div className="text-center py-5">
        <CSpinner color="primary" />
      </div>
    )
  }

  if (!categoria) {
    return (
      <>
        <CRow className="mb-4">
          <CCol className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Categoria</h4>
            <CButton color="secondary" variant="outline" onClick={() => navigate('/catalogos')}>
              <CIcon icon={cilArrowLeft} className="me-1" size="sm" />
              Volver
            </CButton>
          </CCol>
        </CRow>
        <CAlert color="warning">Categoria no encontrada</CAlert>
      </>
    )
  }

  const label = (txt: string) => <div className="factura-etiqueta">{txt}</div>

  return (
    <>
      <CRow className="mb-3">
        <CCol className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <h4 className="mb-0">Categoria {categoria.categoriaNro}</h4>
          <CButton color="secondary" variant="outline" onClick={() => navigate('/catalogos')}>
            <CIcon icon={cilArrowLeft} className="me-1" size="sm" />
            Volver
          </CButton>
        </CCol>
      </CRow>

      <CCard
        className="shadow-sm"
        style={{ borderRadius: 8, maxWidth: 920, borderTop: `4px solid ${PRIMARY_BLUE}` }}
      >
        <CCardBody style={{ padding: '22px 26px' }}>
          {/* ── Encabezado ── */}
          <div className="d-flex justify-content-between align-items-start border-bottom pb-3 mb-3 flex-wrap gap-2">
            <div>
              <div className="fs-4 fw-bold" style={{ color: PRIMARY_BLUE }}>
                {categoria.categoriaNombre || 'Categoria'}
              </div>
              <div className="text-body-secondary small">
                Empresa: {categoria.empresaCodigo || '—'}
              </div>
            </div>
            <div className="text-end">
              <div className="fs-4 fw-bold" style={{ color: PRIMARY_BLUE }}>CATEGORIA</div>
              <div>Nro <span className="fw-semibold">{categoria.categoriaNro}</span></div>
            </div>
          </div>

          <div className="row g-3">
            {/* ── Datos ── */}
            <div className="col-12">
              <div className="factura-panel h-100">
                <h6 className="fw-bold text-primary mb-2" style={{ fontSize: 13 }}>DATOS</h6>
                <div className="row g-1">
                  <div className="col-md-4">
                    {label('Nro')}<div>{categoria.categoriaNro}</div>
                  </div>
                  <div className="col-md-4">
                    {label('Nombre')}<div>{categoria.categoriaNombre || '—'}</div>
                  </div>
                  <div className="col-md-4">
                    {label('Descripcion')}<div>{categoria.categoriaDescripcion || '—'}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </>
  )
}

export default CategoriaViewPage
